<template>
  <div :id="this.$route.name">
    <Card back>
      <template v-slot:header>
        <h4 class="d-inline">تنظیمات سیستم</h4>
        <hr />
      </template>
      <template v-slot:content>
        <Card>
          <template v-slot:header>
            <h5>تنظیمات لاگ</h5>
            <hr />
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-sm-3 col-12">
                <small id="LblmaxLogRecords">سریز لاگ</small>
                <input class="form-control text-left required" type="text" v-model="row.maxLogRecords" @keyup="row.maxLogRecords = $PutCommatoInput_New($event)" @keypress="$ValidNumber($event, 15)" />
              </div>
              <div class="col-sm-3 col-12">
                <small id="LbldeleteLogRecords">تعداد رکود حذف لاگ</small>
                <input class="form-control text-left required" type="text" v-model="row.deleteLogRecords" @keyup="row.deleteLogRecords = $PutCommatoInput_New($event)" @keypress="$ValidNumber($event, 15)" />
              </div>
            </div>
          </template>
        </Card>

        <Card>
          <template v-slot:header>
            <h5>تنظیمات عمومی</h5>
            <hr />
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-sm-3 col-12">
                <small id="LblmaxFaildLogin">حداکثر تعداد ورود ناموفق</small>
                <input class="form-control text-left required" type="number" v-model="row.maxFaildLogin" />
              </div>

              <div class="col-sm-3 col-12">
                <small id="LblmaxFaildLogin">حداقل طول پسورد</small>
                <input class="form-control text-left required" type="number" v-model="row.minPasswordLength" />
              </div>

              <div class="col-sm-3 col-12">
                <small id="LblmaxFaildLogin">حداکثر ورود ناموفق برای فعالسازی کپچا</small>
                <input class="form-control text-left required" type="number" v-model="row.maxFailLoginForCaptcha" />
              </div>
            </div>
          </template>
        </Card>

        <Card>
          <template v-slot:header>
            <h5>اطلاع رسانی</h5>
            <hr />
          </template>
          <template v-slot:content>
            <div class="row">
              <div class="col-sm-3 col-12">
                <small id="LblalertMobile">پنل ارسال پیامک </small>
                <input class="form-control text-left" type="text" v-model="row.smsPanel" />
              </div>
              <div class="col-sm-3 col-12">
                <small id="LblalertMobile">شماره موبایل</small>
                <input class="form-control text-left" @keypress="$ValidNumber($event, 11)" type="text" v-model="row.alertMobile" />
              </div>
              <!-- <div class="col-sm-3 col-12">
                        <small id="LblEmail">ایمیل</small>
                        <input class="form-control text-left" type="text"
                            v-model="row.email" />
                    </div> -->
            </div>
            <!-- <div class="row mr-1">
                    <div class="form-check mt-4 mx-1">
                        <small class="form-check-label mx-1" id="LblsendSmsAlert">
                            ارسال پیامک
                        </small>
                        <input class="form-check-input" type="checkbox" v-model="row.sendSmsAlert">
                    </div>
                    <div class="form-check mt-4 mx-1">
                        <small class="form-check-label mx-1" id="LblsendEmailAlert">
                            ارسال ایمیل
                        </small>
                        <input class="form-check-input" type="checkbox" v-model="row.sendEmailAlert">
                    </div>
                    <div class="form-check mt-4 mx-1">
                        <small class="form-check-label mx-1" id="LblshowNoticBoardAlert">
                            نمایش اعلان در داشبورد
                        </small>
                        <input class="form-check-input" type="checkbox" v-model="row.showNoticBoardAlert">
                    </div>
                </div> -->
          </template>
        </Card>

        <div class="d-flex">
          <button @click="submit()" class="btn btn-success">ثبت</button>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card/Card.vue'
export default {
  components: { Card },
  data() {
    return {
      row: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$PostData_new('get', 'SiteSetting')
        .then((res) => {
          this.row = res
          this.$store.state.OldDataForLog = JSON.stringify(this.row)
          this.row.deleteLogRecords = this.$Comma3ragham(this.row.deleteLogRecords)
          this.row.maxLogRecords = this.$Comma3ragham(this.row.maxLogRecords)
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
    submit() {
      if (this.$ValidForm(this.$route.name) == false) {
        return
      }
      this.row.deleteLogRecords = this.row.deleteLogRecords.replaceAll(',', '')
      this.row.maxLogRecords = this.row.maxLogRecords.replaceAll(',', '')
      console.log(this.row)
      this.$PostData_new('put', 'SiteSetting', this.row)
        .then((res) => {
          if (res.isSuccess) {
            this.$mySweetDefaultTost('عملیات موفق', res.message, 'success', 2000)
            this.$SetLog(this.row, 0)
            this.getData()
          } else {
            this.$mySweetDefaultTost('عملیات ناموفق', res.message, 'info', 2000)
          }
        })
        .catch((err) => {
          this.$mySweetDefaultTost('عملیات ناموفق', 'خطای سمت سرور', 'error', 2000)
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>
hr {
  border: 1px solid var(--sidebar-color-item);
}
</style>
